export default "__VITE_ASSET__D25q$92u__"